import { ContentState } from "draft-js";
import { CurrencyCode } from "@domain/currency/currency";
import { Media } from "@domain/media/media";

export const allPeriods = ["SEVENDAYS", "THREEMONTHS", "SIXMONTHS", "TWELVEMONTHS"] as const;
export type Period = (typeof allPeriods)[number];

export interface ShareroomPresentation {
	video?: Media;
	url?: string;
}

export interface AboutShareroomDraft {
	presentationAsset?: ShareroomPresentation;
	presentation?: ContentState;
	targetAudience?: ContentState;
	objective?: ContentState;
	schedule?: ContentState;
	formatCourse?: ContentState;
}

// export const allSubscriptionMode = ["MONTHLY", "YEARLY", "UNIQUE"] as const;
export const allSubscriptionMode = ["MONTHLY"] as const;

export type SubscriptionMode = (typeof allSubscriptionMode)[number];

export interface ShareroomPricing {
	subscriptionMode: SubscriptionMode;
	priceInUserCurrency: number;
	userCurrency: CurrencyCode;
	price?: number;
	currency?: CurrencyCode;
}

export interface ShareroomFeedback {
	count: number;
	meanScore: number;
	byMe: boolean;
}

export type AboutShareroomDraftField = keyof Omit<AboutShareroomDraft, "presentationAsset">;
